var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading","appear":""}},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-track"})])])}
var staticRenderFns = []

export { render, staticRenderFns }